import { useHead } from '@vueuse/head'

/**
 * Sets per-page <head> tags for SEO and social link previews (Open Graph).
 *
 * Catalog population is handled by the backend product feed, so this only
 * emits the SEO/OG essentials — no product microdata or JSON-LD.
 */
export function usePageMeta({ title, description, image, url, product }) {
  const meta = [
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:type', content: product ? 'product' : 'website' },
    ...(image ? [{ property: 'og:image', content: image }] : []),
    ...(url ? [{ property: 'og:url', content: url }] : []),
  ]

  useHead({ title, meta })
}
